import {styled} from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import {values} from './LegalNoticeData'
import theme from '../../themes'
const PREFIX = 'LegalNoticeTable'

const classes = {
  tableContainerStyle: `${PREFIX}-tableContainerStyle`,
  tableStyle: `${PREFIX}-tableStyle`,
  tableContent: `${PREFIX}-tableContent`,
  tableHeader: `${PREFIX}-tableHeader`
}

const StyledTableContainer = styled(TableContainer)(({theme}) => ({
  [`&.${classes.tableContainerStyle}`]: {
    width: 'inherit',
    marginBottom: '40px',
    backgroundColor: theme.palette.common.white
  },

  [`& .${classes.tableStyle}`]: {
    border: '1px solid black'
  },

  [`& .${classes.tableContent}`]: {
    color: theme.palette.grey[700],
    fontSize: theme.typography.subtitle1.fontSize,
    letterSpacing: '0.25px'
  },

  [`& .${classes.tableHeader}`]: {
    color: theme.palette.common.black,
    fontSize: theme.typography.subtitle1.fontSize,
    letterSpacing: '0.25px'
  }
}))

const rows = values

export default function LegalNoticeTable() {
  return (
    <StyledTableContainer component={Paper} className={classes.tableContainerStyle}>
      <Table aria-label="legal-notice-table" className={classes.tableStyle} size="small" padding="normal">
        <TableHead>
          <TableRow>
            <TableCell tabIndex={0} className={classes.tableHeader} sx={{}} aria-label="Number">
              #
            </TableCell>
            <TableCell tabIndex={0} className={classes.tableHeader} aria-label="Library">
              Library
            </TableCell>
            <TableCell tabIndex={0} className={classes.tableHeader} aria-label="Licenses">
              Licenses
            </TableCell>
            <TableCell tabIndex={0} className={classes.tableHeader} aria-label="Copyrights">
              Copyrights
            </TableCell>
            <TableCell tabIndex={0} className={classes.tableHeader} aria-label="Notices">
              Notices
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell
                component="th"
                scope="row"
                className={classes.tableContent}
                style={{maxWidth: '8px', color: theme.palette.grey[700]}}
              >
                {row['#']}
              </TableCell>
              <TableCell
                tabIndex={0}
                className={classes.tableContent}
                aria-label={`${row.Library}`}
                style={{color: theme.palette.grey[700]}}
              >
                {row.Library}
              </TableCell>
              <TableCell
                tabIndex={0}
                className={classes.tableContent}
                aria-label={`${row.Licenses}`}
                style={{maxWidth: '16px', color: theme.palette.grey[700]}}
              >
                {row.Licenses}
              </TableCell>
              <TableCell
                tabIndex={0}
                className={classes.tableContent}
                aria-label={`${row.Copyrights}`}
                style={{color: theme.palette.grey[700]}}
              >
                {row.Copyrights}
              </TableCell>
              <TableCell
                tabIndex={0}
                className={classes.tableContent}
                aria-label={`${row.Notices}`}
                style={{color: theme.palette.grey[700]}}
              >
                {row.Notices}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  )
}
